<app-atom-spinner [hidden]="!capSpinnerService.spinnerVisible" id="awesome-spinner" [animationDuration]="animationDuration"
                  [size]="size"
                  [color]="color">
</app-atom-spinner>
